module.exports = __webpack_public_path__ + "static/sergey-brin-00812ad87c9c7622bb8d0e774b04860c.jpg";